import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    providers: [],
    loadChildren: () => import('@kinet-open-network/client-zone/shell/feature'),
  },
];
